import React from 'react';
import II18 from '../../translate/II18';

import { Button, Icon } from 'framework7-react';

import PropTypes from 'prop-types';
import { longestWord } from '../../helpers/utils';
import { ZoomButtons } from '../../desktop/Elements';
import { DocumentRejectedMessage } from '../../common/DocumentRejectedMessage';

class ViewerContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imagesReady: false,
      zoom: 70,
      reachEnd: this.props.document.attachment.length === 1
    };
    this.imageCounter = 0;
  }

  componentDidMount() {
    this.scrollBindTimeout = setTimeout(this.bindScrollListener, 500);
  }

  componentWillUnmount() {
    clearTimeout(this.scrollBindTimeout);
    this.unbindScrollListener();
  }

  getScrollPanel = () => {
    const scrollId = this.props.scrollContainer || 'pagesPanel';
    return (
      document.querySelector('.page-current #' + scrollId) ||
      document.getElementById(scrollId)
    );
  };

  bindScrollListener = () => {
    const scrollPanel = this.getScrollPanel();
    if (!scrollPanel) {
      return;
    }
    this.scrollPanel = scrollPanel;
    scrollPanel.onscroll = this.checkReachEnd;
  };

  unbindScrollListener = () => {
    if (this.scrollPanel) {
      this.scrollPanel.onscroll = null;
      this.scrollPanel = null;
    }
  };

  checkReachEnd = () => {
    const scrollPanel = this.getScrollPanel();
    if (!scrollPanel) {
      return;
    }

    if (
      scrollPanel.scrollHeight - scrollPanel.scrollTop <
      scrollPanel.offsetHeight + 50
    ) {
      this.props.onDocumentIsScrolledTillEnd();
    }
  };

  onZoomChange = z => {
    this.setState({
      zoom: z
    });
  };

  render() {
    const {
      document: documentItem,
      onDocumentIsScrolledTillEnd,
      onShowConfirmationDialog,
      showConfirmButton,
      showScrollButton,
      confirmText,
      downloadRequired
    } = this.props;

    const zoom = this.state.zoom;

    /*const scrollToEndOptionEnabled =
      documentItem.attributes.scrollToEndOptionEnabled || 1;*/

    const acceptButtonText = confirmText;

    const hasLongestWord = longestWord(acceptButtonText).length > 25;

    return (
      <div id={'viewerContainer'}>
        {documentItem?.rejected && <DocumentRejectedMessage />}
        <div
          id={'pagesPanel'}
          className={'tinny-scrollbar ' + (zoom < 50 ? ' canZoomIn' : '')}
        >
          {documentItem.attachment.map((url, index) => (
            <div
              onClick={() => {
                if (zoom < 50) {
                  this.setState({ zoom: 70 }, () =>
                    document
                      .getElementById('viewerPage' + index)
                      .scrollIntoView()
                  );
                }
              }}
              id={'viewerPage' + index}
              className={'viewer-page ' + (downloadRequired ? 'blur' : '')}
              key={index}
              style={{
                width: zoom + '%'
              }}
            >
              <img
                alt={`Page ${index + 1}`}
                onLoad={() => {
                  this.imageCounter++;
                  if (this.imageCounter === documentItem.attachment.length) {
                    this.setState({
                      imagesReady: true
                    });
                  }
                }}
                className={'slideImage'}
                src={url}
                style={{ width: '100%', marginBottom: -5 }}
              />
              <label className={'page-number'}>{index + 1}</label>
            </div>
          ))}
          <div id={'viewerEnd'}></div>
        </div>
        <ZoomButtons
          showGridButton
          minZoom={10}
          maxZoom={100}
          initialZoom={zoom}
          onChange={this.onZoomChange}
          botPosition={showConfirmButton ? 95 : 50}
        />

        {showScrollButton && (
          <Button
            id={'scrollButton'}
            fill
            className={'tinyFab viewerFabButton'}
            position="right-bottom"
            slot="fixed"
            text={II18.get('title_had_read')}
            color="deeppurple"
            onClick={() => {
              document.getElementById('viewerEnd').scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'start'
              });
              onDocumentIsScrolledTillEnd();
            }}
          >
            <Icon material={'arrow_downward'} />
          </Button>
        )}

        {showConfirmButton && (
          <div
            style={{
              borderTop: '1px solid #bbb',
              width: '100%',
              paddingTop: 5,
              paddingBottom: 5,
              height: 70,
              background: '#fff',
              boxShadow: '0 0 6px #999',
              zIndex: 100,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end'
            }}
          >
            <Button
              id={'acceptButton'}
              className={hasLongestWord ? ' longerButton' : ''}
              fill
              text={confirmText}
              onClick={onShowConfirmationDialog}
              style={{
                marginRight: '15%',
                width:
                  acceptButtonText.length > 90
                    ? acceptButtonText.length * 3.1
                    : null
              }}
            >
              <Icon material={'done'} />
            </Button>
          </div>
        )}
      </div>
    );
  }
}

ViewerContent.propTypes = {
  downloadRequired: PropTypes.bool,
  scanEnded: PropTypes.bool,
  confirmed: PropTypes.bool,
  onDocumentIsScrolledTillEnd: PropTypes.func,
  onShowConfirmationDialog: PropTypes.func,
  onShowUnConfirmationDialog: PropTypes.func,
  documentIsScrolledTillEnd: PropTypes.bool,
  showAcceptDoneButton: PropTypes.bool,
  showUnConfirmButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  showScrollButton: PropTypes.bool,
  confirmText: PropTypes.string,
  document: PropTypes.object,
  doDownloadAttachment: PropTypes.func,
  doPrintAttachment: PropTypes.func,
  navigateBack: PropTypes.func,
  onDocumentDone: PropTypes.func,
  open: PropTypes.bool,
  isSkipDocumentListMode: PropTypes.bool,
  templateMode: PropTypes.bool,
  scrollContainer: PropTypes.string
};

export default ViewerContent;
